<template>
    <div class="app container">
        <!-- 地图 -->
        <div id="container" class="case-map"></div>

        <div class="header-box">
            <div class="header">
                <div class="left">
                    <div @click="gouloadcase" class="icon-add">发布案例</div>
                </div>
                <div class="middle">
                    <div class="capsule">
                        <div class="seach" @click="getShow">搜索</div>
                        <div class="choice icon-address">
                            <span>{{ sCity ? sCity : "请选择" }}</span>
                        </div>
                    </div>
                </div>
                <!-- <div class="middle" @click="getShow">按条件搜索案例</div> -->
                <!-- <div class="right" @click="show">
                <span>{{ city ? city : "请选择" }}</span>
              </div> -->
            </div>
            <div class="tab-nav">
                <div :style="{'width':(100 / 4) + '%'}" v-for="(item, index) in searchConf.tab" :key="item.code">
                    <p :class="{ active: item.select }" @click="fastSearch(index,item)">
                        {{ item.name }}
                    </p>
                </div>
                <div :style="{'width':(100 / 4) + '%'}">
                    <p @click="toAntMap">冷暖风水</p>
                </div>
                <div :style="{'width':(100 / 4) + '%'}" v-for="(item, index) in searchConf.brand" :key="item.code">
                    <p :class="{ active: item.select }" @click="fastSearch(index,item)">
                        {{ item.name }}
                    </p>
                </div>
                <div :style="{ width: 100 / 4 + '%' }">
                    <p @click="toCommercial">商用净水</p>
                </div>
            </div>
            <div class="search" v-show="bShow">
                <div class="close" @click="getShow"></div>
                <div class="search-box">
                    <div class="leads-box">
                        <div class="input-box">
                            <label>小区名称</label>
                            <input type="text" placeholder="输入小区名称或关键字" v-model="rqname" placeholder-class="place" />
                        </div>
                        <div class="tag-box">
                            <label>案例类型</label>
                            <div class="list">
                                <template v-if="!allCase">
                                    <p :class="{ active: item.select }" @click="setSearchConfKey('topic_type', index)" v-for="(item, index) in searchConf.topic_type" :key="index">
                                        {{ item.name }}
                                    </p>
                                </template>
                                <p :class="{ active: allCase }" @click="selectAllCase()">
                                    全部案例
                                </p>
                            </div>
                        </div>
                        <div class="input-box">
                            <label>产品型号</label>
                            <input type="text" placeholder="输入产品型号搜索" v-model="proType" placeholder-class="place" />
                        </div>
                        <div class="tag-box">
                            <label>产品品类</label>
                            <div class="list">
                                <template v-if="!allCategory">
                                    <p :class="{ active: item.select }" @click="setSearchConfKey('cate', index)" class="tag" v-for="(item, index) in searchConf.cate" :key="index" v-show="item.type==0">
                                        {{ item.name }}
                                    </p>
                                </template>
                                <p :class="{ active: allCategory }" class="tag" @click="selectAllCategory">全部</p>
                            </div>
                        </div>
                        <div class="tag-box">
                            <label>品牌</label>
                            <div class="list">
                                <template>
                                    <p :class="{ active: item.select }" @click="setSearchConfKey('brand', index)" v-for="(item, index) in searchConf.brand" :key="index">
                                        {{ item.name }}
                                    </p>
                                </template>
                            </div>
                        </div>

                    </div>
                    <div class="footer-btn">
                        <p @click.stop="bShow = false">取消</p>
                        <p class="active" @click.stop="getseash(true)">确定</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 案例列表	 -->
        <transition name="collapse-list">
            <case-list :arrCaseList="arrCaseList" @close-case-list="closeCaseList" v-if="isCaseListShow" />
        </transition>

        <!-- 遮罩层 -->
        <div class="mask" @click="isSearchShow = false" v-show="isSearchShow"></div>

        <div class="reposition" @click="reposition()">
            <img src="@/assets/images/navigation.png" alt="" />
        </div>

        <awesome-picker ref="picker" :anchor="anchor" :data="address" :colorConfirm="sColor" :colorCancel="sColor" swipeTime:500 @cancel="handlePickerCancel" @confirm="handlePickerConfirm" v-if="bPicker"></awesome-picker>

        <!-- 侧边栏 -->
        <div class="sidebar">
            <div class="list">
                <div class="item" @click="gocasemap">
                    <img src="~@/assets/images/case/icon_list.png" />
                    <p>列表<br />模式</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import addressPicker from "../../components/select/erji_select.vue";
import MapLoader from "@/libs/AMap.js";
import caseList from "@/components/case-list";
import path from "@/path";
import PullTo from "vue-pull-to";

export default {
    components: {
        // addressPicker,
        PullTo,
        caseList,
    },
    data() {
        return {
            allCategory: false, // 是否选择所有品类
            objList: {}, //省市id
            anchor: [
                {
                    index: 0,
                    value: "",
                },
                {
                    index: 0,
                    value: "",
                },
            ], //默认选中
            sColor: "#2395ff", //picker取消确定按钮颜色
            arrAnchor: [], //初始化默认值
            address: [], //地级联动列表
            addressData: [], //未解析的地级联动列表
            addressObj: {
                province: "",
                city: "",
                area_id: "",
            },
            bPicker: false,
            isMapShow: true,
            isSearchShow: false, // 搜索显示
            isCaseListShow: false, // 案例列表显示
            domeCity: "",
            sCity: "",
            sProvince: "",
            // 121.492901,31.22506
            nLatitude: 0,
            nLongitude: 0,

            arrAreaList: [],
            arrCaseList: [],

            bShow: false,
            // 搜索配置文件
            rqname: "", //小区名字搜索
            proType: "",
            searchConf: {
                house_area: [],
                cate: [],
                topic_type: [],
            },
            tab: "",
            sort: {
                time_desc: 0,
                time_asc: 0,
                shares: 0,
                collect_num: 0,
            },
            userinfo: {}, //用户信息

            bSearch: false, // 是否为搜索模式
            allCase: false,

            // 地图
            map: {},
            arrMarkers: [], //标记点
            nActiveIndex: null,
            nName: "",
            cCityId: 0,
            groupType: "community",
            objTran: {}, //城市数据
        };
    },
    async created() {
        this.sCity = this.$route.query.city;
        this.domeCity = this.$route.query.city;
        this.sProvince = this.$route.query.province;
        this.nLatitude = this.$route.query.latitude || "";
        this.nLongitude = this.$route.query.longitude || "";
        if (!this.positionTip()) return;
        this.getCityIdByName().then(res=>{
            this.initMap();
        })
        path.post5(path.topicGetConf).then((res) => {
            if (res.data.error == 0) {
                for (let key in res.data.data.result) {
                    let item = res.data.data.result[key];
                    for (let subitem of item) {
                        subitem.select = false;
                    }
                }
                res.data.data.result.cate.forEach((it) => {
                    it.type = 0;
                });
                res.data.data.result.brand.forEach((it) => {
                    it.type = 2;
                    // res.data.data.result.tab.push(it)
                });
                res.data.data.result.tab.forEach((it) => {
                    it.type = 1;
                    res.data.data.result.cate.push(it);
                });
                this.searchConf = res.data.data.result;
            } else {
                this.$store.commit("loadSwitch", false);
                this.$toast({
                    message: res.data.msg,
                    position: "bottom",
                    duration: 1200,
                });
            }
        });
    },
    methods: {
        // 获取城市id
        getCityIdByName() {
            return new Promise(rus=>{
                let _that = this;
                path.post5(path.TOOL_TRANSITION_INDEX, {
                    user_id: this.$route.query.tp5Userid,
                    cityName: this.sCity,
                    provinceName: this.sProvince,
                }).then((res) => {
                    _that.objTran = res.data.data.result;
                    rus()
                });
            })
        },
        positionTip() {
            const can = !!this.nLatitude && !!this.nLongitude;
            !can &&
                this.$toast("定位失败，请允许获取位置信息后重新进入", {
                    duration: 2000,
                });
            return can;
        },
        initMap() {
            let that = this;
            MapLoader().then((AMap) => {
                that.$store.commit("loadSwitch", true);
                let map = new AMap.Map("container", {
                    center: [this.nLongitude, this.nLatitude],
                    expandZoomRange: true,
                    zoom: 15,
                    zooms: [10, 20],
                    showIndoorMap: false, // 是否在有矢量底图的时候自动展示室内地图，PC默认true,移动端默认false
                    resizeEnable: true, //是否监控地图容器尺寸变化，默认值为false
                    dragEnable: true, // 地图是否可通过鼠标拖拽平移，默认为true
                    keyboardEnable: false, //地图是否可通过键盘控制，默认为true
                    doubleClickZoom: false, // 地图是否可通过双击鼠标放大地图，默认为true
                    zoomEnable: true, //地图是否可缩放，默认值为true
                    rotateEnable: false, // 地图是否可旋转，3D视图默认为true，2D视图默认false
                    scrollWheel: true,
                });
                that.map = map;
                if(map){
                    map.on("complete", function () {
                        // console.log("地图加载完成！");
                        that.logMapBounds().then((res) => {
                            that.getAreaListV5(res);
                        });
                    });
                }

                // 地图移动结束
                map.on("moveend", function () {
                    if (!that.isMapShow) {
                        return false;
                    }
                    that.dataSeash().then((rust) => {
                        that.$store.commit("loadSwitch", true);
                        that.logMapBounds().then((res) => {
                            if (that.arrMarkers.length) {
                                map.remove(that.arrMarkers);
                            }
                            let data = Object.assign(res, rust);
                            that.getAreaListV5(data);
                        });
                    });
                });
                (e) => {
                    console.log("地图加载失败", e);
                };
            });
        },

        // 获取屏幕可视距离标记点
        logMapBounds() {
            return new Promise((resolve, reject) => {
                const bounds = this.map.getBounds();
                const zoom = this.map.getZoom();
                let northeast = bounds.northeast.toString().split(",");
                let southwest = bounds.southwest.toString().split(",");

                const groupNum = (20 - zoom) * 90;
                groupNum >= 0 && (this.groupType = `community`);
                groupNum >= 500 && (this.groupType = `district`);
                groupNum >= 2000 && (this.groupType = `city`);
                groupNum >= 10000 && (this.groupType = `province`);

                let obj = {
                    max_longitude: northeast[0],
                    max_latitude: northeast[1],
                    min_longitude: southwest[0],
                    min_latitude: southwest[1],
                    city_id: this.objTran.city,
                    groupType: this.groupType,
                    source: "xcx",
                };
                resolve(obj);
            });
        },
        selectAllCategory() {
            this.allCategory = !this.allCategory;
            this.searchConf.cate.forEach((item) => (item.select = false));
        },
        toAntMap() {
            wx.miniProgram.redirectTo({ url: "/pages/ant_map/index/index" });
        },
        toCommercial(){
            wx.miniProgram.redirectTo({ url: "/pages/business/map/index" });
        },
        selectAllCase() {
            if (this.allCase) {
                for (let item of this.searchConf.topic_type) {
                    item.select = false;
                }
            } else {
                for (let item of this.searchConf.topic_type) {
                    item.select = true;
                }
            }
            this.allCase = !this.allCase;
        },
        //跳转小程序发布案例
        gouloadcase() {
            this.$store.commit("loadSwitch", true);
            path.post5(path.getUser, {
                user_id: this.$route.query.tp5Userid,
            }).then((res) => {
                // console.log("用户信息", res);
                this.userinfo = res.data.data.result;
                this.$store.commit("loadSwitch", false);
                //判断是否为直销员  ==0  不是直销员
                if (res.data.data.result.sell_id == 0) {
                    // this.$toast({
                    // message: "您不是直销员",
                    // duration: 500,
                    // });
                    // setTimeout(() => {
                    wx.miniProgram.navigateTo({
                        url: "/pages/phoneauth/index?url=/pages/case/case_release_xue1/index&userid=0&topicid=0",
                    });
                    // }, 500);
                } else {
                    wx.miniProgram.navigateTo({
                        url: "/pages/case/case_release_xue1/index",
                    });
                }
            });
        },
        //picker点击取消
        handlePickerCancel: function () {
            let that = this;
            if (that.bCancel) {
                that.bCancel = false;
                that.anchor = that.arrSelect;
            } else {
                that.bCancel = false;
                // that.anchor = that.anchor;
            }

            this.bPicker = false;
        },
        handlePickerConfirm(e) {
            //console.log("确定", e);
            let that = this;
            that.caseList = [];
            that.page = 0;
            let select = e;
            that.arrSelect = select;
            let addressData = that.addressData;
            let objprovinces = addressData[0].find((item) => {
                return item.name.indexOf(select[0].value.slice(0, 2)) > -1;
            });
            // //console.log("-->省", objprovinces);
            if (objprovinces) {
                let objCity = addressData[objprovinces.id].find((item) => {
                    // //console.log('=>provincestest',item.name.indexOf(province.slice(0,2)))
                    return item.name.indexOf(select[1].value.slice(0, 2)) > -1;
                });
                let provinceId = objprovinces.id;
                let cityId = objCity.id;
                let province = objprovinces.name;
                let city = objCity.name;
                let obj = {};
                obj.city_id = cityId;
                obj.province_id = provinceId;
                that.objList = obj;
                that.bCancel = true;
                that.city = city;
                that.getseash();
            }
        },
        fastSearch(index, item) {
            if (item.type == 1) {
                // 设置当前选中项
                this.searchConf.tab[index].select =
                    !this.searchConf.tab[index].select;
                const active = this.searchConf.cate.findIndex(
                    (item) => item.code == this.searchConf.tab[index].code
                );
                // console.log(this.searchConf.cate);
                // 设置 cate 中的选中项
                if (~active) {
                    this.searchConf.cate[active].select =
                        this.searchConf.tab[index].select;
                }
                // 去除不限的选中项
                this.searchConf["cate"].forEach((it, nIt) => {
                    if (it.code == 0) {
                        it.select = false;
                    }
                });
            } else if (item.type == 2) {
                this.searchConf.brand[index].select =
                    !this.searchConf.brand[index].select;
                const active = this.searchConf.cate.findIndex(
                    (item) => item.code == this.searchConf.brand[index].code
                );
                // 设置 cate 中的选中项
                if (~active) {
                    this.searchConf.cate[active].select =
                        this.searchConf.brand[index].select;
                }
                // 去除不限的选中项
                this.searchConf["brand"].forEach((it, nIt) => {
                    if (it.code == 0) {
                        it.select = false;
                    }
                });
            }
            this.getseash();
        },
        setSearchConfKey(key, index) {
            if (key == "cate" && this.searchConf[key][index].code == 0) {
                if (this.searchConf[key][index].select) {
                    this.searchConf[key].forEach((it, nIt) => {
                        if (it.code != 0) {
                            it.select = false;
                        }
                    });
                } else {
                    this.searchConf[key].forEach((it, nIt) => {
                        if (it.code != 0) {
                            it.select = true;
                        }
                    });
                }
                this.searchConf[key][index].select =
                    !this.searchConf[key][index].select;
            } else {
                this.searchConf[key].forEach((it, nIt) => {
                    // console.log(it);
                    if (it.code == 0) {
                        it.select = false;
                    }
                });
                this.searchConf[key][index].select =
                    !this.searchConf[key][index].select;
            }
        },
        //点击搜索案例初始化
        getShow: function () {
            this.bShow = !this.bShow;
        },
        //跳转附近案例
        gocasemap() {
            wx.miniProgram.redirectTo({
                url: "/pages/case/case_list_vue/index",
            });
        },
        closeCaseList() {
            this.isCaseListShow = false;
        },
        showCaseList(e) {
            this.isCaseListShow = false;
            this.getCaseList(e.id);
        },
        //二级联动
        show() {
            this.bPicker = true;
            setTimeout(() => {
                this.$refs.picker.show();
            }, 100);
        },
        // 重新定位
        reposition() {
            this.map.setCenter([this.$route.query.longitude, this.$route.query.latitude]);
            // this.isMapShow = false;
            // this.nLatitude = this.$route.query.latitude || "";
            // this.nLongitude = this.$route.query.longitude || "";
            // this.getAreaList();
        },
        // 获取小区位置
        getAreaListV5(res) {
            const requestUrl = path.topicSearchplotsV5;
            this.$store.commit("loadSwitch", true);
            path.post5(requestUrl, res).then((res) => {
                this.arrAreaList = res.data.data.result.list.filter(
                    (_) => _.topic_total !== 0
                );
                if (this.arrAreaList.length !== 0) {
                    this.createMarker(this.arrAreaList);
                    setTimeout(() => {
                        this.getCaseList(this.arrAreaList[0].id);
                    }, 500);
                } else {
                    this.$store.commit("loadSwitch", false);
                    this.$toast("该位置附近无案例小区~");
                }
                this.bSearch = false;
            });
        },
        // 创建标注
        createMarker() {
            const that = this;
            const markers = [];
            //自定义聚合的样式
            const _renderMarker = function (item) {
                let content;
                if (item.total >= 10000) {
                    content =
                        '<div class="ant-map-marker-five-big">' +
                        '<div class="text-five-big">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (item.total >= 1000) {
                    content =
                        '<div class="ant-map-marker-four-big">' +
                        '<div class="text-four-big">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (item.total >= 100) {
                    content =
                        '<div class="ant-map-marker-big">' +
                        '<div class="text-big">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (item.total >= 10) {
                    content =
                        '<div class="ant-map-marker-red-sm">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                } else if (item.total < 10) {
                    content =
                        '<div class="ant-map-marker-blue">' +
                        '<div class="text">' +
                        item.total +
                        "</div>" +
                        "</div>";
                }
                return content;
            };

            this.arrAreaList.forEach((item, index) => {
                let markerContent = _renderMarker(item);
                let markerOnContent =
                    '<div class="ant-map-marker-yellow">' +
                    '<div class="text">' +
                    item.total +
                    "</div>" +
                    "</div>";
                const marker = new AMap.Marker({
                    zIndex: index + 1,
                    position: new AMap.LngLat(
                        Number(item.longitude),
                        Number(item.latitude)
                    ),
                    content: markerContent,
                    extData: {
                        id: index,
                        name: item.total,
                    },
                    offset: new AMap.Pixel(-13, -30),

                    animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
                });
                // 绑定点击事件
                marker.on("click", function ({ lat, lng, type, target }) {
                    that.map.setZoom(15);
                    const zoomNow = that.map.getZoom();
                    if (that.groupType === "community") {
                        that.$store.commit("loadSwitch", true);
                        if (that.nActiveIndex !== null) {
                            that.arrMarkers[that.nActiveIndex].setContent(
                                '<div class="ant-map-marker-blue">' +
                                    '<div class="text">' +
                                    that.nName +
                                    "</div>" +
                                    "</div>"
                            );
                        }
                        // 设置当前标注颜色
                        target.setContent(markerOnContent);
                        // // 记住当前索引
                        that.nActiveIndex = target.getExtData().id;
                        that.nName = target.getExtData().name;
                        // 传递参数父组件
                        that.showCaseList({ ...item });
                    } else {
                        that.map.setZoomAndCenter(
                            zoomNow < 14 ? zoomNow + 1 : zoomNow + 2,
                            new AMap.LngLat(
                                Number(item.longitude),
                                Number(item.latitude)
                            )
                        );
                    }
                });
                markers.push(marker);
            });

            // 当前位置标注
            let markerContentNow =
                '<div class="ant-map-marker-yellow">' + "</div>";
            let markerNow = new AMap.Marker({
                position: new AMap.LngLat(
                    this.$route.query.longitude,
                    this.$route.query.latitude
                ),
                content: markerContentNow,
                offset: new AMap.Pixel(-42, -125),
                animation: "AMAP_ANIMATION_DROP", // AMAP_ANIMATION_BOUNCE
            });
            markers.push(markerNow);
            this.arrMarkers = markers;
            this.map.add(markers);
            that.$store.commit("loadSwitch", false);
        },
        // 获取搜索参数
        dataSeash() {
            return new Promise((res, error) => {
                let arr = [];
                for (let item of this.searchConf.house_area) {
                    // 选中的访问面积
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let area = arr.join(",");

                arr = [];
                let arrBx = this.searchConf.cate.filter((it) => {
                    // 判断品类中的不限是否选中，选中会被添加到数组中
                    return it.select && it.code == 0;
                });
                if (arrBx.length) {
                    // 如果选中了品类中的不限
                    arr.push(0);
                } else {
                    // 未选中品类中的不限
                    for (let item of this.searchConf.cate) {
                        if (item.select) {
                            arr.push(item.code);
                        }
                    }
                }
                let parent_id = arr.join(","); // 选中的品类
                arr = [];
                for (let item of this.searchConf.brand) {
                    // 案列类型
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let brand_id = arr.join(",");
                arr = [];
                let type;
                for (let item of this.searchConf.topic_type) {
                    // 案列类型
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                if(this.searchConf.topic_type.length == arr.length){
                    type = 'all'
                }else{
                    type = arr.join(",");
                }
                let data = {
                    user_id: this.$route.query.userid,
                    search_keys: this.rqname,
                    page: 1,
                    limit: 20,
                    parent_id: parent_id,
                    model: this.proType,
                    type: type,
                    area: area,
                    brand_id: brand_id,
                };
                res(data);
            });
        },
        // 搜索缩小屏幕
        setZoom() {
            let that = this;
            return new Promise((res) => {
                that.map.setZoom(3);
                res();
            });
        },
        // 搜索获取案例
        async getseash(from = false) {
            let that = this;
            that.isMapShow = false;
            that.setZoom().then((res) => {
                setTimeout(() => {
                    that.dataSeash().then((rust) => {
                        that.logMapBounds().then((res) => {
                            if (that.arrMarkers.length) {
                                that.map.remove(that.arrMarkers);
                            }
                            that.isMapShow = true;
                            let data = Object.assign(res, rust);
                            that.getAreaListV5(data);
                        });
                        that.bShow = false;
                        that.bSearch = true;
                    });
                }, 500);
            });
        },

        // 获取案例
        getCaseList(id) {
            if (this.groupType !== "community") return;
            this.dataCaseList(id).then((reult) => {
                const requestUrl = path.getCaseList;
                path.post5(requestUrl, reult).then((res) => {
                    let resultData = res;
                    this.arrCaseList = resultData.data.data.result.lists;
                    this.$store.commit("loadSwitch", false);
                    this.isCaseListShow = true;
                });
            });
        },
        // 获取案例参数
        dataCaseList(id) {
            return new Promise((res, error) => {
                this.isCaseListShow = false;
                let arr = [];
                for (let item of this.searchConf.house_area) {
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                let area = arr.join(",");

                arr = [];
                let arrBx = this.searchConf.cate.filter((it) => {
                    return it.select && it.code == 0;
                });
                if (arrBx.length) {
                    arr.push(0);
                } else {
                    for (let item of this.searchConf.cate) {
                        if (item.select) {
                            arr.push(item.code);
                        }
                    }
                }
                let parent_id = arr.join(",");

                arr = [];
                let type;
                for (let item of this.searchConf.topic_type) {
                    if (item.select) {
                        arr.push(item.code);
                    }
                }
                if(this.searchConf.topic_type.length == arr.length){
                    type = 'all'
                }else{
                    type = arr.join(",");
                }
                const requestData = {
                    plot_id: id,
                    source: "xcx",
                    search_keys: this.rqname,
                    parent_id: parent_id,
                    model: this.proType,
                    type: type,
                    area: area,
                };
                res(requestData);
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.case-map {
    width: 100%;
    height: 100vh;
}

@import "../index";
@import "index";
</style>